import React, {ReactNode} from 'react';

import {AiUsageProvider} from 'src/modules/ai';
import {OktaWrapper} from 'src/modules/authentication/okta-provider';
import {SentryController} from 'src/sentry';
import {DesignToolProvider} from 'src/store/DesignToolProvider';

import {PushNotification} from '@pb/kit-component-push-notification';

type Props = {
    children: ReactNode,
};

export const AppProviders = ({children}: Props) => {
    return (
        <OktaWrapper>
            <DesignToolProvider>
                <AiUsageProvider>
                    <SentryController>
                        <PushNotification>
                            {children}
                        </PushNotification>
                    </SentryController>
                </AiUsageProvider>
            </DesignToolProvider>
        </OktaWrapper>
    );
};
